import { render } from "./PersonalData.vue?vue&type=template&id=1d78dbed&scoped=true"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"

import "./PersonalData.vue?vue&type=style&index=0&id=1d78dbed&lang=scss&scoped=true"

import exportComponent from "/srv/cometo/aos_anmeldung/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d78dbed"]])

export default __exports__